import { render, staticRenderFns } from "./CancelPublishRequest.vue?vue&type=template&id=4b5c8418"
import script from "./CancelPublishRequest.vue?vue&type=script&lang=js"
export * from "./CancelPublishRequest.vue?vue&type=script&lang=js"
import style0 from "./CancelPublishRequest.vue?vue&type=style&index=0&id=4b5c8418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports